import { Dispatch } from "redux";
import request from "../../util/request";
import actions from "../../util/actions";
import errorHandler from "../../util/error-handler";

export const getMinistryKittySubtractions = (_id: string, search: string, page: number, per_page: number) => {
  return (dispatch: Dispatch): void => {
    dispatch({
      type: actions.MINISTRY_KITTY_SUBTRACTIONS_HTTP_LOADING
    });

    request({
      method: "get",
      pathname: "getMinistryKittySubtractions",
      params: { _id, search, page, per_page }
    })
      .then((response) => {
        dispatch({
          type: actions.MINISTRY_KITTY_SUBTRACTIONS_HTTP_COMPLETE,
          payload: {
            response: response
          }
        });

        dispatch({
          type: actions.SET_MINISTRY_KITTY_SUBTRACTIONS_DETAILS,
          payload: {
            ...response.data.content
          }
        });
      })
      .catch((error) => {
        errorHandler(actions.MINISTRY_KITTY_SUBTRACTIONS_HTTP_ERROR, error, dispatch);
      });
  };
};
